import React from "react";

export const CalendarIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.22505 13.0336C9.22505 12.783 9.01723 12.5801 8.76081 12.5801H7.14075C6.88462 12.5801 6.67676 12.783 6.67676 13.0336V14.6175C6.67676 14.8684 6.88462 15.0714 7.14075 15.0714H8.76081C9.01723 15.0714 9.22505 14.8684 9.22505 14.6175V13.0336Z"
				fill="#8C8F93"
			/>
			<path
				d="M13.2741 13.0336C13.2741 12.783 13.0663 12.5801 12.8103 12.5801H11.1901C10.9339 12.5801 10.7261 12.783 10.7261 13.0336V14.6175C10.7261 14.8684 10.9339 15.0714 11.1901 15.0714H12.8103C13.0663 15.0714 13.2741 14.8684 13.2741 14.6175V13.0336Z"
				fill="#8C8F93"
			/>
			<path
				d="M17.3227 13.0336C17.3227 12.783 17.1148 12.5801 16.8587 12.5801H15.2387C14.9822 12.5801 14.7744 12.783 14.7744 13.0336V14.6175C14.7744 14.8684 14.9822 15.0714 15.2387 15.0714H16.8587C17.1148 15.0714 17.3227 14.8684 17.3227 14.6175V13.0336Z"
				fill="#8C8F93"
			/>
			<path
				d="M9.22505 16.9928C9.22505 16.7419 9.01723 16.5391 8.76081 16.5391H7.14075C6.88462 16.5391 6.67676 16.7419 6.67676 16.9928V18.5765C6.67676 18.8272 6.88462 19.0302 7.14075 19.0302H8.76081C9.01723 19.0302 9.22505 18.8271 9.22505 18.5765V16.9928Z"
				fill="#8C8F93"
			/>
			<path
				d="M13.2741 16.9928C13.2741 16.7419 13.0663 16.5391 12.8103 16.5391H11.1901C10.9339 16.5391 10.7261 16.7419 10.7261 16.9928V18.5765C10.7261 18.8272 10.9339 19.0302 11.1901 19.0302H12.8103C13.0663 19.0302 13.2741 18.8271 13.2741 18.5765V16.9928Z"
				fill="#8C8F93"
			/>
			<path
				d="M17.3227 16.9928C17.3227 16.7419 17.1148 16.5391 16.8589 16.5391H15.2387C14.9822 16.5391 14.7744 16.7419 14.7744 16.9928V18.5765C14.7744 18.8272 14.9822 19.0302 15.2387 19.0302H16.8589C17.1148 19.0302 17.3227 18.8271 17.3227 18.5765V16.9928Z"
				fill="#8C8F93"
			/>
			<path
				d="M20.2198 4.22744V6.64677C20.2198 7.74028 19.3126 8.62148 18.1944 8.62148H16.9168C15.7986 8.62148 14.8793 7.74028 14.8793 6.64677V4.21875H9.12064V6.64677C9.12064 7.74028 8.20144 8.62148 7.08339 8.62148H5.80549C4.6874 8.62148 3.78023 7.74028 3.78023 6.64677V4.22744C2.80301 4.25624 2 5.04694 2 6.01881V20.1972C2 21.1874 2.82073 22.0006 3.83332 22.0006H20.1666C21.1777 22.0006 22 21.1857 22 20.1972V6.01881C22 5.04694 21.197 4.25624 20.2198 4.22744ZM19.6264 19.3143C19.6264 19.7422 19.2715 20.0894 18.8338 20.0894H5.13129C4.69352 20.0894 4.33871 19.7422 4.33871 19.3143V11.9906C4.33871 11.5626 4.69348 11.2154 5.13129 11.2154H18.8337C19.2715 11.2154 19.6263 11.5626 19.6263 11.9906L19.6264 19.3143Z"
				fill="#8C8F93"
			/>
			<path
				d="M5.80106 7.32396H7.06484C7.44843 7.32396 7.75945 7.02028 7.75945 6.64519V2.67901C7.75945 2.30388 7.44843 2 7.06484 2H5.80106C5.41742 2 5.10645 2.30388 5.10645 2.67901V6.64519C5.10645 7.02028 5.41742 7.32396 5.80106 7.32396Z"
				fill="#8C8F93"
			/>
			<path
				d="M16.9006 7.32396H18.1644C18.5477 7.32396 18.8588 7.02028 18.8588 6.64519V2.67901C18.8588 2.30388 18.5478 2 18.1644 2H16.9006C16.5171 2 16.2061 2.30388 16.2061 2.67901V6.64519C16.2061 7.02028 16.5171 7.32396 16.9006 7.32396Z"
				fill="#8C8F93"
			/>
		</svg>
	);
};
